import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/600.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/space-mono/400.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./company-ui/company-ui.css";
import "./shell/shell.css";
import "./help/help.css";
import "./auth/auth.css";
import "./auth/sign-in-panels.css";
import "./templates/templates.css";
import { App } from "./App";
import { ToastProvider } from "./company-ui";
import { applyTheme } from "./shell/theme";

applyTheme();
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
